export const SUCCESS_CODE = 200;
export const ERROR_STATUS_KEY = "ERROR";
export const INVALID_USER_EMAIL = "101001";
export const MAX_RESEND_PASSWORD_RETRIES_EXCEED = "101004";
export const MAX_NUMBER_OF_RETRIES = "900001";
export const ACTIVATION_LINK_EXPIRED = "900004";
export const INVALID_USER_EMAIL_OR_STATUS = "101007";
export const NOT_FOUND_USER_EMAIL = "101008";
export const PAYMENT_NOT_APPLIED = "148025";
export const PLAN_CREDIT_EXCEEDS_PRICE = "148024";
export const SEAT_COUNT_BELOW_IN_USE = "148026";
export const QUEUED_PLAN_EXISTS = "148027";
export const PLAN_ORDER_ALREADY_PAID = "148029";
export const PLAN_CHANGE_AWAITING_PAYMENT = "148030";
export const PLAN_ORDER_AWAITING_PAYMENT = "148031";
